export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/three_essentials_bg_hover-8c3b86a9810609794720649dc9d41e47.svg";